export const EtatFeedback = {
  INITIALISATION: "INITIALISATION",
  AUCUN_DEVIS_SELECTIONNE: "AUCUN_DEVIS_SELECTIONNE",
  ENQUETE_SATISFACTION: "ENQUETE_SATISFACTION",
  PROPOSITION_REPUBLICATION: "PROPOSITION_REPUBLICATION",
  ENQUETE_SATISFACTION_RENSEIGNEE: "ENQUETE_SATISFACTION_RENSEIGNEE",
};
